module.exports = __webpack_public_path__ + "img/197.86c7f769.jpg";